import request from "@/utils/request";

// 查询富文本内容
export function getCmsByCodeApi(params) {
  return request({
    url: "/index/cms/contentByCode",
    method: "get",
    params
  });
}
